var map = {
	"./Card_club_10.svg": "dfd7",
	"./Card_club_2.svg": "d520",
	"./Card_club_3.svg": "bc0d",
	"./Card_club_4.svg": "3abb",
	"./Card_club_5.svg": "6101",
	"./Card_club_6.svg": "fa7c",
	"./Card_club_7.svg": "54ce",
	"./Card_club_8.svg": "cb8d",
	"./Card_club_9.svg": "4add",
	"./Card_club_A.svg": "4cb7",
	"./Card_club_J.svg": "0a76",
	"./Card_club_K.svg": "0b84",
	"./Card_club_Q.svg": "1556",
	"./Card_diamond_10.svg": "890f",
	"./Card_diamond_2.svg": "4855",
	"./Card_diamond_3.svg": "5cc2",
	"./Card_diamond_4.svg": "15f8",
	"./Card_diamond_5.svg": "8bca",
	"./Card_diamond_6.svg": "ccfd",
	"./Card_diamond_7.svg": "dec4",
	"./Card_diamond_8.svg": "17a7",
	"./Card_diamond_9.svg": "a745",
	"./Card_diamond_A.svg": "3c20",
	"./Card_diamond_J.svg": "233c",
	"./Card_diamond_K.svg": "bf0e",
	"./Card_diamond_Q.svg": "7061",
	"./Card_heart_10.svg": "1af2",
	"./Card_heart_2.svg": "8924",
	"./Card_heart_3.svg": "df1b",
	"./Card_heart_4.svg": "4e23",
	"./Card_heart_5.svg": "14b3",
	"./Card_heart_6.svg": "d1f7",
	"./Card_heart_7.svg": "e9b6",
	"./Card_heart_8.svg": "603f",
	"./Card_heart_9.svg": "8b10",
	"./Card_heart_A.svg": "f57f",
	"./Card_heart_J.svg": "1f18",
	"./Card_heart_K.svg": "1a23",
	"./Card_heart_Q.svg": "f561",
	"./Card_spade_10.svg": "b14d",
	"./Card_spade_2.svg": "0980",
	"./Card_spade_3.svg": "5c82",
	"./Card_spade_4.svg": "1357",
	"./Card_spade_5.svg": "5c6b",
	"./Card_spade_6.svg": "fe17",
	"./Card_spade_7.svg": "e13d",
	"./Card_spade_8.svg": "fac6",
	"./Card_spade_9.svg": "fb43",
	"./Card_spade_A.svg": "a503",
	"./Card_spade_J.svg": "db9e",
	"./Card_spade_K.svg": "a4f2",
	"./Card_spade_Q.svg": "d97a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d43a";